<template>
    <div ref="sidewindow" class="md:ml-4 w-full md:max-w-[40vw]  max-w-[700px]">
        <div
            class="w-full min-h-[95vh] z-[6] p-3 md:z-[4] md:min-h-[75vh] md:h-full rounded-3xl bg-white dark:bg-neutral-900/20 dark:backdrop-blur-xl ring-1 !ring-black/10 dark:!ring-neutral-300/10 dark:text-white">
            <!-- EMPTY STATE -->
            <div v-if="filtered.length === 0" class="p-4 text-sm text-gray-500 dark:text-neutral-400">
                No results found for <strong>{{ query }}</strong>
            </div>

            <!-- RESULTS LIST -->
            <div class="space-y-3">
                <div v-for="location in filtered" :key="location.slug" @click="$emit('select', location)" class="p-4 rounded-xl bg-white dark:bg-neutral-900/20 dark:backdrop-blur-xl ring-1 !ring-black/10 dark:!ring-neutral-300/10 dark:text-white
                    transition-all">
                    <div class="flex justify-between items-center">
                        <h3 class="text-base font-medium text-gray-800 dark:text-neutral-100">
                            {{ getTranslated(location.name) }}
                        </h3>

                        <div :class="`shrink-0 flex gap-2 items-center`">
                            <div :class="`${meta(location.type).color}`">
                                <svg-vue class="h-4" :icon="meta(location.type).icon" />
                            </div>
                            <div :class="`${meta(location.type).color} text-xs`">
                                {{ meta(location.type).label }}
                            </div>
                        </div>
                    </div>

                    <p class="text-sm text-gray-500 dark:text-neutral-400 mt-1">
                        {{ location.street }}
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>
  
<script>
import { useTypeMeta } from '../../helpers/useTypeMeta'
export default {
    name: "searchResult",

    props: {
        query: {
            type: String,
            required: true
        },
        locations: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        meta(type) {
            return useTypeMeta(type)
        },
        getTranslated(item, lang = 'en') {
            if (!item) return '';

            const translations = item[lang] || item['en'];
            return translations;
        },
    },

    computed: {
        filtered() {
            return this.locations;
        }
    }
};
</script>
  